export default __webpack_public_path__ + "static/media/clipboard-check-white.df8d5d78.svg";